import { createContext } from 'react';

const InventoryContext = createContext({
    show: [],
    setShow: () => {},
});

export default InventoryContext;
